// client/src/pages/Weddings/steps/DessertsStep/utils/math.js
export function snapQtyPieces(qty, minPieces, stepPieces) {
  const q = Math.max(0, Math.floor(Number(qty) || 0));
  if (q === 0) return 0;
  const snapped = Math.ceil(q / stepPieces) * stepPieces;
  return Math.max(snapped, minPieces);
}
